<template>
  <div class="has-background-white">
    <div class="is-padding">
      <div class="columns is-gapless is-vcentered">
        <div class="column is-narrow is-margin-right">
          <span
            class="vadPicto is-large has-text-white tooltip is-tooltip-right"
            :data-tooltip="pictoTooltipMessage"
            :class="pictoColorClass">
            <span><i class="fas fa-people-arrows" /></span>
          </span>
        </div>
        <div class="column is-narrow is-minW230p is-margin-right">
          <div class="is-size-6">
            Date : {{ shareIntent.created_on | prettyDate }}
          </div>
          <div>
            <span v-if="isPromoteur">Destinataire : {{ account.name }}</span>
            <span v-else>Promoteur:
              <router-link
                v-if="accounts.find(a=>a.name===promoteur.name).promoteur_details_activated"
                class="is-linkTextPicto"
                :to="{name: 'PromoteurPresentation', params: {id: promoteur.pk}}">
                <span class="">{{ promoteur.name }}</span>
              </router-link>
              <b v-else>{{ promoteur.name }}</b>
            </span>
          </div>
        </div>
        <div class="column">
          <div class="is-size-6">
              &nbsp;
          </div>
          <span
            class="tooltip is-tooltip-bottom is-margin-right-small"
            :data-tooltip="tooltipMessage">
            Nombre de contact : <b>{{ shareIntent.proposals.length }}</b>
          </span>
          <span
            class="is-underline has-cursor-pointer is-size-6"
            @click="isOpen = !isOpen">Afficher les contacts</span>
        </div>
        <div class="column is-narrow">
          <div
            v-if="pendingContacts.length > 0"
            class="field is-grouped">
            <p
              v-if="confirmationButton"
              class="control">
              <button
                class="button is-xsmall is-danger is-minW120p"
                @click="refuseAll">
                <span class="is-uppercase">Confirmer votre refus</span>
              </button>
            </p>
            <p
              v-if="isDistributeurAdmin && !confirmationButton"
              class="control">
              <button
                class="button is-xsmall is-link is-minW120p"
                @click="beforeRefuseAll">
                <span class="is-uppercase">Tout Refuser</span>
              </button>
            </p>
            <p
              v-if="isDistributeurAdmin && !confirmationButton"
              class="control">
              <button
                class="button is-xsmall is-success is-minW120p"
                @click="acceptAll">
                <span class="is-uppercase">Tout Accepter</span>
              </button>
            </p>
            <p
              v-if="isPromoteurAdmin"
              class="control">
              <button
                class="button is-xsmall is-dark is-minW100p"
                @click="removeAll">
                <span class="is-uppercase">Tout Annuler</span>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isOpen"
      class="is-border-top">
      <table class="table is-fullwidth is-striped-v">
        <tbody class="has-cells-vcentered has-text-centered">
          <tr
            v-for="proposal in orderedProposals"
            :key="proposal.contact.pk"
            class="is-size-6">
            <td class="has-text-centered is-padding-top-small is-padding-bottom-small">
              <router-link
                :to="{name: 'ContactVue', params: {id: proposal.contact.pk}}"
                class="fullLink">
                {{ proposal.contact.last_name }}
              </router-link>
            </td>
            <td class="has-text-centered">
              <router-link
                :to="{name: 'ContactVue', params: {id: proposal.contact.pk}}"
                class="fullLink">
                {{ proposal.contact.first_name }}
              </router-link>
            </td>
            <td class="has-text-centered">
              Email : {{ proposal.contact.email | prettyBool }}
            </td>
            <td class="has-text-centered">
              Téléphone : {{ proposal.contact.phone | prettyBool }}
            </td>
            <td class="has-text-centered">
              Adresse :
              <span v-if="proposal.contact.address">{{ proposal.contact.address.city }}({{ proposal.contact.address.zip_code }})</span>
              <span v-else>NC</span>
            </td>
            <td
              v-if="isDistributeurAdmin && proposal.status === CONTACT_PROPOSAL_STATUS.PENDING"
              class="has-text-right">
              <button
                class="button is-xsmall is-margin-right-xsmall is-light is-border is-transform-none is-radius"
                @click="askProposalUpdate([proposal.contact.pk], CONTACT_PROPOSAL_STATUS.REFUSED)">
                <span class="is-uppercase">Refuser</span>
              </button>
              <button
                class="button is-xsmall is-light is-border is-transform-none is-radius"
                @click="askProposalUpdate([proposal.contact.pk], CONTACT_PROPOSAL_STATUS.APPROVED)">
                <span class="is-uppercase">Accepter</span>
              </button>
            </td>
            <td
              v-else-if="proposal.status === CONTACT_PROPOSAL_STATUS.REFUSED"
              class="has-text-right">
              <span
                class="icon is-medium is-size-4 has-text-danger tooltip is-tooltip-left"
                data-tooltip="Contact refusé">
                <i class="fas fa-lg fa-times-circle" />
              </span>
            </td>
            <td
              v-else-if="proposal.status === CONTACT_PROPOSAL_STATUS.PENDING"
              class="has-text-right">
              <span
                class="icon is-medium is-size-4 has-text-waiting_list tooltip is-tooltip-left"
                data-tooltip="En attente">
                <i class="fal fa-lg fa-hourglass-half" />
              </span>
              <button
                v-if="isPromoteurAdmin"
                class="button is-xsmall is-light is-border is-transform-none is-radius"
                @click="remove(proposal.contact.pk)">
                <span class="is-uppercase">Annuler</span>
              </button>
            </td>
            <td
              v-else-if="proposal.status === CONTACT_PROPOSAL_STATUS.TERMINATED"
              class="has-text-right">
              <span
                class="icon is-medium is-size-4 has-text-danger tooltip is-tooltip-left"
                data-tooltip="Partage annulé">
                <i class="fas fa-lg fa-times-circle" />
              </span>
            </td>
            <td
              v-else
              class="has-text-right">
              <span
                class="icon is-medium is-size-4 has-text-success tooltip is-tooltip-left"
                data-tooltip="Contact accepté">
                <i class="fas fa-lg fa-check-circle" />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { CONTACT_PROPOSAL_STATUS, SHARE_INTENT_STATUS } from '../../mixins/DefaultValues'
import { sortBy } from 'lodash'

export default {
  name: 'ShareIntentItem',
  props: {
    shareIntent: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmationButton: false,
      CONTACT_PROPOSAL_STATUS: CONTACT_PROPOSAL_STATUS,
      isOpen: false
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isDistributeur', 'isAdmin', 'accounts']),
    ...mapState(['currentUser', 'modal']),
    isPromoteurAdmin () {
      return this.isPromoteur && this.isAdmin
    },
    isDistributeurAdmin () {
      return this.isDistributeur && this.isAdmin
    },
    account () {
      return this.shareIntent.account
    },
    promoteur () {
      return this.shareIntent.promoteur
    },
    proposals () {
      return this.shareIntent.proposals
    },
    orderedProposals () {
      return sortBy(this.proposals, ['contact.last_name', 'contact.first_name'])
    },
    pendingContacts () {
      return this.shareIntent.proposals
        .filter(x => x.status === CONTACT_PROPOSAL_STATUS.PENDING)
        .map(x => x.contact)
    },
    pendingContactPkList () {
      return this.pendingContacts.map(x => x.pk)
    },
    status () {
      return this.shareIntent.status
    },
    pictoColorClass () {
      const colors = {
        [SHARE_INTENT_STATUS.PENDING]: 'has-background-draft',
        [SHARE_INTENT_STATUS.REFUSED]: 'has-background-danger',
        [SHARE_INTENT_STATUS.APPROVED]: 'has-background-success',
        [SHARE_INTENT_STATUS.PARTIALLY_APPROVED]: 'has-background-waiting_list'
      }
      return colors[this.status]
    },
    pictoTooltipMessage () {
      const colors = {
        [SHARE_INTENT_STATUS.PENDING]: 'Partage en attente',
        [SHARE_INTENT_STATUS.REFUSED]: 'Partage refusé',
        [SHARE_INTENT_STATUS.APPROVED]: 'Partage accepté',
        [SHARE_INTENT_STATUS.PARTIALLY_APPROVED]: 'Partage accepté partiellement'
      }
      return colors[this.status]
    },
    pendingProposals () {
      return this.shareIntent.proposals.filter(x => x.status === 'pending')
    },
    acceptedProposals () {
      return this.shareIntent.proposals.filter(x => x.status === 'approved')
    },
    refusedProposals () {
      return this.shareIntent.proposals.filter(x => x.status === 'refused')
    },
    tooltipMessage () {
      return `Acceptés : ${this.acceptedProposals.length} / ${this.proposals.length}`
    }
  },
  methods: {
    async askProposalUpdate (contactPkList, status) {
      await this.$emit('updateProposal', {
        shareIntentPk: this.shareIntent.pk,
        contactPkList: contactPkList,
        status: status
      })
    },
    async acceptAll () {
      await this.askProposalUpdate(this.pendingContactPkList, CONTACT_PROPOSAL_STATUS.APPROVED)
    },
    beforeRefuseAll () {
      this.confirmationButton = true
    },
    async refuseAll () {
      await this.askProposalUpdate(this.pendingContactPkList, CONTACT_PROPOSAL_STATUS.REFUSED)
      this.confirmationButton = false
    },
    async removeAll () {
      await this.$emit('removeAllShareIntent', {
        shareIntentPk: this.shareIntent.pk
      })
    },
    async remove (contactPk) {
      let intentPk = this.shareIntent.pk
      await this.$emit('removeShareIntent', contactPk, intentPk)
    }
  }
}
</script>
